define( [ 'utility', 'vendor/cookie' ], function run( utility, cookie ) {
	'use strict';

	var mNotificationBadgeFn = {

		notificationHeight : 2.1875, /* 35px / 16px */

		init : function( elm ) {
			var elmId,
				wrapperElm,
				cookieName = 'ion_notification',
				cookieNameAttr;

			if ( !elm.mNotificationBadge ) {
				elm.mNotificationBadge = {}; // Setup mNotificationBadge object
			}

			if ( cookie.cookie.get( cookieName ) === 'True' ) {
				elm.remove();
				wrapperElm = document.querySelector( '.m-site-country-selection__notification' );
				if ( wrapperElm ) {
					wrapperElm.remove();
				}
			} else if ( elm.classList.contains( 'js-m-notification-badge' ) ) {
				// Do nothing
			} else {
				elm.classList.add( 'js-m-notification-badge' );

				elm.mNotificationBadge.wrapperElm = document.querySelector( '.m-site-country-selection__notification' );

				// Set the cookie name to custom name if provided
				cookieNameAttr = elm.getAttribute( 'data-cookie-name' );
				if ( cookieNameAttr !== null && cookieNameAttr !== '' ) {
					cookieName = cookieNameAttr;
				}

				// If the cookie has already been set remove the notification straight away
				if ( cookie.cookie.get( cookieName ) === 'True' ) {
					elm.remove();
					if ( elm.mNotificationBadge.wrapperElm ) {
						elm.mNotificationBadge.wrapperElm.remove();
					}
				} else {
					elmId = elm.getAttribute( 'id' );
					if ( !elmId ) {
						elmId = utility.makeId( 'm-notification-badge-' );
						elm.setAttribute( 'id', elmId );
					}

					mNotificationBadgeFn.setupCloseButton( elm, elmId, cookieName );

					mNotificationBadgeFn.setupResizeObserver( elm );
				}
			}

			mNotificationBadgeFn.setupApiFunctions( elm, cookieName );

			return elm.mNotificationBadge;
		},

		setupApiFunctions : function( elm, cookieName ) {
			elm.mNotificationBadge.close = function close() {
				if ( elm.classList.contains( 'js-m-notification-badge' ) ) {
					mNotificationBadgeFn.close( elm, cookieName );
				}
			};

			elm.mNotificationBadge.show = function show() {
				if ( elm.classList.contains( 'js-m-notification-badge' ) && elm.mNotificationBadge.wrapperElm ) {
					mNotificationBadgeFn.showHide( elm, true );
				}
			};

			elm.mNotificationBadge.hide = function hide() {
				if ( elm.classList.contains( 'js-m-notification-badge' ) && elm.mNotificationBadge.wrapperElm ) {
					mNotificationBadgeFn.showHide( elm, false );
				}
			};
		},

		setupCloseButton : function( elm, elmId, cookieName ) {
			var closeElm = elm.querySelector( '.m-notification-badge__close' );

			// If there is no close button already create one
			if ( !closeElm ) {
				closeElm = utility.htmlStringToElement( '<button class="m-notification-badge__close" type="button">' + FRAMEWORK.locale.settings.mNotificationBadge.closeText + '</button>' );
				elm.append( closeElm );
			}

			closeElm.setAttribute( 'aria-controls', elmId );

			closeElm.addEventListener( 'click', function listener( e ) {
				e.preventDefault();

				mNotificationBadgeFn.close( elm, cookieName );
			});
		},

		close : function( elm, cookieName ) {
			var secureCookie = true;

			if ( cookie.cookie.enabled() ) {
				// If cookies are enabled set a cookie so this message no longer appears
				if ( document.location.protocol === 'http:' ) {
					secureCookie = false;
				}

				cookie.cookie.set( cookieName, 'True', {
					secure : secureCookie,
					path : '/',
					sameSite : 'Strict',
				});

				mNotificationBadgeFn.announceClose( true );
			} else {
				mNotificationBadgeFn.announceClose( false );
			}

			utility.slideToggle( elm, FRAMEWORK.timings.current.t350ms, {
				variant : 'up',
				callback : function() {
					elm.remove();
					if ( elm.mNotificationBadge.wrapperElm ) {
						elm.mNotificationBadge.wrapperElm.remove();
						window.removeEventListener( 'resize', elm.mNotificationBadge.windowResizeListener );
					}
				},
			});
		},

		showHide : function( elm, showNotification, fromResize ) {
			var ariaHidden = 'true',
				newDisplayType = 'none';

			if ( showNotification || elm.mNotificationBadge.singleRow ) {
				ariaHidden = 'false';
				newDisplayType = 'flex';
			}
			elm.mNotificationBadge.wrapperElm.setAttribute( 'aria-hidden', ariaHidden );
			elm.mNotificationBadge.wrapperElm.style.display = newDisplayType;

			if ( showNotification && !fromResize ) {
				elm.mNotificationBadge.windowResizeListener();
			}
		},

		setupResizeObserver : function( elm ) {
			var elmResizeObserver;

			if ( elm.mNotificationBadge.wrapperElm ) {
				elm.mNotificationBadge.barElm = document.querySelector( '.m-site-country-selection' );
				elm.mNotificationBadge.countrySelectorBtn = document.querySelector( '.js-m-site-country-selection__country' );
				elm.mNotificationBadge.siteSwitcherBtn = document.querySelector( '.m-site-country-selection__site-switcher a' );

				elm.mNotificationBadge.windowResizeListener = utility.debounce( function debounceFunc() {
					var fontSize = utility.removeMeasurementSuffix( window.getComputedStyle( elm.mNotificationBadge.barElm ).fontSize );

					elm.mNotificationBadge.barElm.classList.add( 'm-site-country-selection--single-row' );
					elm.mNotificationBadge.singleRow = true;
					mNotificationBadgeFn.showHide( elm, true, true );
					if ( elm.offsetHeight > ( mNotificationBadgeFn.notificationHeight * fontSize ) ) {
						elm.mNotificationBadge.barElm.classList.remove( 'm-site-country-selection--single-row' );
						elm.mNotificationBadge.singleRow = false;
						if ( elm.mNotificationBadge.countrySelectorBtn && elm.mNotificationBadge.countrySelectorBtn.classList.contains( 'is-open' ) ) {
							mNotificationBadgeFn.showHide( elm, false, true );
						} else if ( elm.mNotificationBadge.siteSwitcherBtn && elm.mNotificationBadge.siteSwitcherBtn.classList.contains( 'is-open' ) ) {
							mNotificationBadgeFn.showHide( elm, false, true );
						}
					}
				}, 10 );

				window.addEventListener( 'resize', elm.mNotificationBadge.windowResizeListener );
				elm.mNotificationBadge.windowResizeListener();
			}

			if ( 'ResizeObserver' in window ) {
				// Check if the notification is a single line. If so apply alternative styling.
				elmResizeObserver = new ResizeObserver( function listener( entries ) {
					var fontSize = utility.removeMeasurementSuffix( window.getComputedStyle( elm.mNotificationBadge.barElm ).fontSize );

					entries.forEach( function loop( entry ) {
						if ( entry.contentBoxSize[ 0 ].blockSize > ( mNotificationBadgeFn.notificationHeight * fontSize ) ) {
							elm.classList.remove( 'm-notification-badge--shallow' );
						} else {
							elm.classList.add( 'm-notification-badge--shallow' );
						}
					});
				});

				elmResizeObserver.observe( elm );
			}
		},

		announceClose : function( success ) {
			// Enable aria alert that cookie policy settings successfully saved
			var cookieMessage,
				cookieMessageText;

			if ( success ) {
				// Do nothing
			} else {
				cookieMessageText = document.createTextNode( FRAMEWORK.locale.settings.mNotificationBadge.failed );

				cookieMessage = document.createElement( 'p' );
				cookieMessage.setAttribute( 'role', 'alert' );
				cookieMessage.classList.add( 'u-hidden--visually' );
				cookieMessage.append( cookieMessageText );
				document.body.append( cookieMessage );

				// Time out to remove cookie successfully saved message
				setTimeout( function timeoutFn() {
					cookieMessage.remove();
				}, 5000 );
			}
		},
	};

	return {
		initInstance : function( el ) {
			return mNotificationBadgeFn.init( el );
		},
	};
});
